// src/icons/NonagonCheckmark.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function NonagonCheckmark() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_1_2)", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.00009 0.166443C6.12679 0.166443 6.24725 0.221364 6.33031 0.316995L7.59831 1.77637L9.50773 1.47348C9.63286 1.45363 9.76043 1.489 9.8575 1.57043C9.95456 1.65187 10.0116 1.77137 10.0137 1.89804L10.047 3.83105L11.7044 4.82637C11.813 4.89162 11.888 5.0007 11.91 5.12548C11.932 5.25025 11.8988 5.37841 11.8191 5.47682L10.6021 6.97902L11.2319 8.80678C11.2732 8.92659 11.2605 9.05837 11.1972 9.16809C11.1338 9.27782 11.026 9.3547 10.9017 9.37879L9.00379 9.74723L8.31143 11.5523C8.26605 11.6706 8.17161 11.7634 8.05255 11.8067C7.93349 11.8501 7.80154 11.8396 7.69076 11.7782L6.00009 10.8405L4.30941 11.7782C4.19862 11.8396 4.06663 11.8501 3.94758 11.8067C3.82853 11.7634 3.7341 11.6706 3.68873 11.5523L2.99634 9.74723L1.09848 9.37879C0.974113 9.3547 0.866319 9.27782 0.802969 9.16809C0.739625 9.05837 0.726949 8.92659 0.768226 8.80678L1.39809 6.97902L0.181066 5.47682C0.101312 5.37841 0.0681439 5.25025 0.0901473 5.12548C0.112145 5.0007 0.18715 4.89162 0.295761 4.82637L1.95315 3.83105L1.98642 1.89804C1.98861 1.77137 2.04559 1.65187 2.14264 1.57043C2.2397 1.489 2.36728 1.45363 2.49241 1.47348L4.40182 1.77637L5.66981 0.316995C5.75293 0.221364 5.87339 0.166443 6.00009 0.166443ZM7.76776 5.57995C7.93862 5.40909 7.93862 5.13213 7.76776 4.96127C7.59691 4.7904 7.31988 4.7904 7.14902 4.96127L5.41676 6.69353L4.8511 6.12793C4.68025 5.95708 4.40323 5.95708 4.23238 6.12793C4.06153 6.29879 4.06153 6.57576 4.23238 6.74662L5.10736 7.62162C5.18943 7.70369 5.30073 7.74978 5.41676 7.74978C5.53278 7.74978 5.64408 7.70369 5.7261 7.62162L7.76776 5.57995Z",
              fill: "#0068C9"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M7.76776 5.57989C7.93862 5.40903 7.93862 5.13207 7.76776 4.96121C7.59691 4.79034 7.31988 4.79034 7.14902 4.96121L5.41676 6.69347L4.8511 6.12787C4.68025 5.95702 4.40323 5.95702 4.23238 6.12787C4.06153 6.29873 4.06153 6.5757 4.23238 6.74656L5.10736 7.62156C5.18943 7.70363 5.30073 7.74972 5.41676 7.74972C5.53278 7.74972 5.64408 7.70363 5.7261 7.62156L7.76776 5.57989Z",
              fill: "#F9F9F9"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_1_2", children: /* @__PURE__ */ jsx("rect", { width: "12", height: "12", fill: "white" }) }) })
      ]
    }
  );
}

export {
  NonagonCheckmark
};
